<template>
  <gas-page-shell :breadcrumb="['系统设置', '数据备份']">
    <el-form :inline="true" :model="query" size="small" class="search-form">
      <el-form-item label="关键词"><el-input v-model="query.keyword" clearable placeholder="文件名/操作人" /></el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="toolbar table-title-row">
      <div class="table-title-group">
        <span class="table-title">备份列表 <em>共 {{ total }} 条记录</em></span>
        <gas-table-toolbar
          :columns="tableColumnDefs"
          :visible-map.sync="tableColumnVisible"
          :selected-count="selectedIds.length"
          :show-batch-delete="tableCanBatchDelete"
          @batch-delete="batchRemove"
        />
      </div>
      <el-button type="primary" size="small" icon="el-icon-download" :loading="creating" @click="createBackup">创建备份</el-button>
    </div>
    <el-table :data="list" v-loading="loading" border size="small" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="44" align="center" />
      <el-table-column prop="fileName" label="文件名" min-width="200" />
      <el-table-column prop="filePath" label="路径" min-width="160" show-overflow-tooltip />
      <el-table-column label="大小" width="100">
        <template slot-scope="{ row }">{{ formatSize(row.fileSize) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="96">
        <template slot-scope="{ row }"><gas-status-tag kind="backup" :value="row.backupStatus" /></template>
      </el-table-column>
      <el-table-column prop="operatorName" label="操作人" width="100" />
      <el-table-column prop="backupTime" label="备份时间" min-width="150" />
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      <el-table-column label="操作" width="80" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" class="danger" @click="removeRow(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" background layout="total, sizes, prev, pager, next"
      :total="total" :current-page="query.pageNum" :page-size="query.pageSize"
      :page-sizes="[10,20,50]" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
  </gas-page-shell>
</template>

<script>
import GasPageShell from '@/components/GasPageShell.vue'
import gasCrudPage from '@/mixins/gasCrudPage'
import { gasApi } from '@/api/gas'

export default {
  components: { GasPageShell },
  mixins: [gasCrudPage],
  data() {
    return {
      idField: 'backupId',
      listApi: gasApi.backup.list,
      saveApi: null,
      removeApi: gasApi.backup.remove,
      batchRemoveApi: gasApi.backup.batchRemove,
      query: { pageNum: 1, pageSize: 10, keyword: '' },
      creating: false,
      backupRefreshTimer: null
    }
  },
  beforeDestroy() {
    if (this.backupRefreshTimer) clearTimeout(this.backupRefreshTimer)
  },
  methods: {
    async loadData() {
      await gasCrudPage.methods.loadData.call(this)
      this.scheduleRunningRefresh()
    },
    formatSize(bytes) {
      const n = Number(bytes || 0)
      if (n < 1024) return n + ' B'
      if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB'
      return (n / 1024 / 1024).toFixed(2) + ' MB'
    },
    async createBackup() {
      this.creating = true
      try {
        await gasApi.backup.create()
        this.$message.success('备份任务已创建，生成完成后会自动刷新')
        this.loadData()
      } finally {
        this.creating = false
      }
    },
    scheduleRunningRefresh() {
      if (this.backupRefreshTimer) clearTimeout(this.backupRefreshTimer)
      const hasRunning = (this.list || []).some(row => row.backupStatus === 'running')
      if (hasRunning) {
        this.backupRefreshTimer = setTimeout(() => this.loadData(), 3000)
      }
    }
  }
}
</script>

<style scoped>
.toolbar { margin-bottom:12px; display:flex; gap:8px; }
.search-form { margin-bottom:8px; }
.pager { margin-top:16px; text-align:right; }
.danger { color:#f53f3f; }
</style>
